<template lang="pug">
div.mb-sm-3
    table.table.table-striped
        thead: tr
            th(scope="col") {{showSubcollections ? "Subcollection" : "Collection"}}
            th(scope="col") Type
            th(scope="col") Materials
            th(scope="") #Samples
            th(scope="" v-if="showFactColumn") Facts
            th(scope="") Cohort
            //-th(scope="") Note
        tbody: tr(v-for="collection in collections" v-if="!collection.parent_collection || showSubcollections")
            td
                router-link(:to="'/'+(showSubcollections ? 'collections' : 'collections')+'/' + collection.id") {{collection.name}}
                div(v-if="subcollectionCount[collection.id]")
                    | (+ {{subcollectionCount[collection.id]}} subcollections)
            td {{ getCollectionType(collection) }}
            td {{ getCollectionMaterials(collection) }}
            td {{ collection.size }}
            td(v-if="showFactColumn")
                span.badge.badge-light(v-if="!collection.fact_info || !collection.fact_info.has_facts") none
                span(v-else)
                    span.badge.badge-primary.mr-1(v-if="collection.fact_info.explicit_count > 0") explicit: {{collection.fact_info.explicit_count}}
                    span.badge.badge-info(v-if="collection.fact_info.derived_count > 0") from subcollections: {{collection.fact_info.derived_count}}
            td(style="text-align:center")
                i.pi.pi-check(v-if="collection.flagged_as_cohort")
            //-td
              span.red {{ headMessage(collection) }}
</template>
<script>
import countBy from "lodash.countby";
import CollectionTypeLabels from "../labels/CollectionTypes.json";
import MaterialTypeLabels from "../labels/MaterialTypes.json";

export default {
    props: {
        "collections" : Array,
        "showSubcollections": {
            type: Boolean,
            default: true
        },
        "showFactColumn": {
            type: Boolean,
            default: true
        }
    },
    methods: {
        getCollectionType(collection) {
//            console.log(collection);
//            console.log(collection.type[0]);
            return collection.type && collection.type
            .map(t => CollectionTypeLabels[t].label)
            .join(", ");
        },
        getCollectionMaterials(collection) {
            return collection.materials && collection.materials
            .map(m => MaterialTypeLabels[m])
            .join(", ");
        },
        headMessage(collection) {
          return collection.head == null ? "Head is not set" : "";
        }
    },
    computed: {
        subcollectionCount() {
            return countBy(this.collections, "parent_collection")
        }
    }
}
</script>
<style scoped>
.red {
  color: red;
}
</style>
